/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import BWCurrencyInput from 'src/bw/bw-currency-input/BW-Currency-Input';
import BWPercentInput from 'src/bw/bw-percent-input/BW-Percent-Input';
import { Label, Input } from '@americanexpress/dls-react';

import './EditableField.scss';

export default class EditableField extends Component<any> {
    public override state = {
        editing: false,
        tempValue: '' as string
    };

    public override render(): ReactComponentElement<any> {
        let field: JSX.Element;
        let fieldClass: string = '';

        if (this.props.currencyAdornment) {
            field = (
                <BWCurrencyInput
                    fullWidth
                    label={this.props.label}
                    value={this.props.editValue}
                    showFractions={this.props.showFractions}
                    onChange={(value: number) => {
                        this.handleChange(value);
                    }}
                    onKeyUp={async (e: any) => this.handleKeyUp(e)}
                />
            );
            fieldClass = 'currency';
        } else if (this.props.percentageAdornment) {
            field = (
                <BWPercentInput
                    fullWidth
                    label={this.props.label}
                    value={this.props.editValue}
                    onChange={(e: any) => this.handleChange(e.target.value)}
                    onKeyUp={async (e: any) => this.handleKeyUp(e)}
                />
            );
            fieldClass = 'percent';
        } else {
            field = (
                <React.Fragment>
                    {this.props.label ? <Label htmlFor={this.props.id}>{this.props.label}</Label> : null}
                    <Input
                        id={this.props.id}
                        placeholder={this.props.placeholder}
                        value={this.props.editValue}
                        onChange={(e: any) => this.handleChange(e.target.value)}
                    />
                </React.Fragment>
            );
        }

        return (
            <div
                className={`editable-field ${fieldClass} ${this.props.className ? this.props.className : ''}`}
                key={this.props.id ? this.props.id : 'editable-field'}
                id={this.props.id ? this.props.id : 'editable-field'}
            >
                {field}
            </div>
        );
    }

    private handleKeyUp(event: any): void {
        if (event.keyCode === 13) {
            if (this.props.handleEnter) {
                this.props.handleEnter(this.state.tempValue);
            } else {
                this.props.handleSave(this.state.tempValue);
            }
            this.setState({
                editing: false
            });
        }
    }

    private handleChange(value: number | string): void {
        this.setState({
            tempValue: value
        });

        this.props.handleSave(value);
    }
}
